module.exports = __webpack_public_path__ + "img/ban_2big.a0e1f0fe.png";